import { I18nt } from 'utils';
import { Rule } from 'antd/lib/form';
import { LangText } from 'utils/interfaces';
import { Form, Input, Select as AntSelect } from 'antd';

interface InputTextProps {
	label?: LangText;
	placeholder?: LangText;
	name: string;
	rules?: Rule[];
	value?: string;
	defaultValue?: string;
	inputMode?:
		| 'email'
		| 'search'
		| 'text'
		| 'none'
		| 'tel'
		| 'url'
		| 'numeric'
		| 'decimal';
}

export function InputText({
	name,
	rules,
	label,
	inputMode,
	placeholder,
}: InputTextProps) {
	return (
		<Form.Item
			name={name}
			rules={rules}
			label={label ? I18nt(label as LangText) : ''}
		>
			<Input
				inputMode={inputMode}
				placeholder={placeholder ? I18nt(placeholder as LangText) : ''}
			/>
		</Form.Item>
	);
}
interface SelectProps extends InputTextProps {
	options: {
		value: string;
		label: string;
	}[];
}

export function Select({
	label,
	placeholder,
	options,
	name,
	rules,
	value,
	defaultValue,
}: SelectProps) {
	return (
		<Form.Item
			name={name}
			rules={rules}
			label={label ? I18nt(label as LangText) : ''}
		>
			<AntSelect
				showArrow
				options={options}
				placeholder={placeholder ? I18nt(placeholder as LangText) : ''}
				value={value}
				defaultValue={defaultValue}
			/>
		</Form.Item>
	);
}

interface TextAreaProps extends InputTextProps {
	showCount?: boolean;
	maxLength?: number;
	size?: number;
}

export function TextArea({
	label,
	name,
	rules,
	showCount,
	maxLength,
	placeholder,
	size,
}: TextAreaProps) {
	return (
		<Form.Item
			name={name}
			rules={rules}
			label={label ? I18nt(label as LangText) : ''}
		>
			<Input.TextArea
				autoSize={{ minRows: size, maxRows: size }}
				showCount={showCount}
				maxLength={maxLength}
				placeholder={placeholder ? I18nt(placeholder as LangText) : ''}
			/>
		</Form.Item>
	);
}
